<template>
  <div>
    <p v-if="plaintext" class="my-2">{{ formattedValue }}</p>
    <date-picker
        v-else
        v-bind="$attrs"
        :editable="editable"
        :disabled="disabled"
        :clearable="clearable"
        :format="format"
        :value-type="valueType"
        :input-class="`form-control ${state === false ? 'is-invalid' : (state === true ? 'is-valid' : '')}`"
        :value="valueDate"
        :type="type"
        :placeholder="placeholder"
        @input="onInput"
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { isArray } from 'lodash'

export default {
  model: {
    event: 'input'
  },
  components:{
    DatePicker
  },
  props: {
    value: [String, Number, Array],
    state: {
      type: Boolean,
      default: null
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    valueType:{
      type: String,
      default: 'date'
    },
    prefixClass: {
      type: String,
      default: 'mx'
    },
    type: {
      type: String,
      default: 'datetime'
    },
    plaintext: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {

    }
  },
  computed:{
    formattedValue() {
      if (isArray(this.value)) {
        return this.value.map((v) => {
          return this.$moment.utc(v).local().format(this.format);
        })
      }
      if (this.value) return this.$moment.utc(this.value).local().format(this.format);
      return this.value
    },
    valueDate() {
      if (isArray(this.value)) {
        return this.value.map((v) => {
          return this.$moment.utc(v).local().toDate();
        })
      }
      if (this.value) return this.$moment.utc(this.value).local().toDate();
      return this.value
    }
  },
  methods: {
    onInput(event) {
      const value = event && event.target ? event.target.value : event;
      if (value) {
        if (isArray(value)) {
          this.$emit('input', value.map((v) => {
            return this.type === 'date' ? this.$moment(v).format('YYYY-MM-DD') : this.$moment(v).utc().format('YYYY-MM-DD HH:mm:ss');
          }));
        } else {
          this.$emit('input', this.type === 'date' ? this.$moment(value).format('YYYY-MM-DD') : this.$moment(value).utc().format('YYYY-MM-DD HH:mm:ss'));
        }
      } else {
        this.$emit('input',  null);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .is-valid {
    ~ .mx-icon-calendar {
      right: calc(1.5em + 0.94rem);
    }
    ~ .mx-icon-clear {
      right: calc(1.5em + 0.94rem);
    }
  }
  .is-invalid {
    ~ .mx-icon-calendar {
      right: calc(1.5em + 0.94rem);
    }
    ~ .mx-icon-clear {
      right: calc(1.5em + 0.94rem);
    }
  }
}
</style>
